import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { useRefCallback } from '@tencent/glue-react-use';
import { Success, CloseOne } from '@tencent/adp-icons-react';
import { getFormatVideoDuration } from '../common/utils';
import { usePrefixCls } from '../../../../config/hooks/usePrefixCls';
import { Link } from '@tencent/glue-react-ui';
export var MaterialListItem = function MaterialListItem(props) {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    progress = _useState2[0],
    setProgress = _useState2[1];
  var intervalRef = useRef();
  var url = props.url,
    _props$name = props.name,
    name = _props$name === void 0 ? '未知' : _props$name,
    _props$desc = props.desc,
    desc = _props$desc === void 0 ? 'xxxxxx 5.91k' : _props$desc,
    isActive = props.isActive,
    _props$activeColor = props.activeColor,
    activeColor = _props$activeColor === void 0 ? '#296BEF' : _props$activeColor,
    id = props.id,
    duration = props.duration,
    onClick = props.onClick,
    style = props.style,
    _props$isUploading = props.isUploading,
    isUploading = _props$isUploading === void 0 ? false : _props$isUploading,
    _props$errorMessage = props.errorMessage,
    errorMessage = _props$errorMessage === void 0 ? '' : _props$errorMessage,
    retry = props.retry;
  useEffect(function () {
    if (!isUploading || errorMessage) {
      clearInterval(intervalRef.current);
      return;
    }
    intervalRef.current = setInterval(function () {
      setProgress(function (value) {
        return value + 10;
      });
    }, 500);
    return function () {
      clearInterval(intervalRef.current);
    };
  }, [isUploading]);
  var rootCls = usePrefixCls('material-library-material-list-item');
  var itemCls = usePrefixCls('material-library-material-list-item', {
    active: isActive
  });
  var clickHandle = useRefCallback(function () {
    return onClick === null || onClick === void 0 ? void 0 : onClick(id);
  });
  return React.createElement("div", {
    className: itemCls,
    style: style,
    onClick: clickHandle
  }, isActive && React.createElement(Success, {
    className: "".concat(rootCls, "-active-icon"),
    fill: activeColor
  }), errorMessage ? React.createElement("div", {
    className: "".concat(rootCls, "-preview-image")
  }, React.createElement("div", {
    className: "".concat(rootCls, "-uploading-mask")
  }, React.createElement("div", {
    className: 'error-message'
  }, React.createElement(CloseOne, {
    style: {
      marginBottom: 5
    },
    fill: "#FD433B",
    size: 24
  }), React.createElement("div", {
    style: {
      width: '55%'
    }
  }, errorMessage, ", ", React.createElement(Link, {
    style: {
      display: 'inline'
    },
    onClick: retry
  }, "\u91CD\u65B0\u4E0A\u4F20"))))) : React.createElement(React.Fragment, null, !isUploading && React.createElement("div", {
    className: "".concat(rootCls, "-preview-image"),
    style: {
      backgroundImage: "url(".concat(url, ")")
    }
  }, duration ? React.createElement("i", {
    className: "".concat(rootCls, "-duration")
  }, getFormatVideoDuration(duration)) : null), isUploading && React.createElement("div", {
    className: "".concat(rootCls, "-preview-image")
  }, React.createElement("div", {
    className: "".concat(rootCls, "-uploading-mask")
  }, React.createElement("div", {
    className: 'progress'
  }, React.createElement("div", {
    className: 'progressBar',
    style: {
      width: "".concat(progress, "%")
    }
  })), "\u4E0A\u4F20\u4E2D"))), React.createElement("div", {
    className: "".concat(rootCls, "-info")
  }, React.createElement("p", {
    className: "".concat(rootCls, "-info-name")
  }, name), React.createElement("p", {
    className: "".concat(rootCls, "-info-desc")
  }, desc)));
};